export const isMobileDevice = (): boolean => {
  return "ontouchstart" in document.documentElement;
};
export const formatDate = (date: string) => {
  if (date === "-" || date === "") {
    return "N/A";
  }
  const utc_date = new Date(+date).toUTCString();
  const extracted_date = utc_date.substring(5, 16);
  return new Date(extracted_date).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
};
export const toNumber = (value: string | number | null | undefined): number => {
  if(value === null || value === undefined) {
    return 0;
  }
  return Number(
    value
      .toString()
      .replace(/,/g, "")
      .replace(/[^0-9.-]+/g, "")
  )
};
export const formatNumber = (number: number, fixed = 2) => {
  return toNumber(number).toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const formatPoints = (number: number) => {
  return toNumber(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const formatCurrency = (amount: number|string): string => {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(amount));
  } catch {
    return `$ ${formatNumber(Number(amount))}`;
  }
};
export const scrollToTop = () => {
  document.getElementById("top")?.scrollIntoView({ behavior: "smooth" });
};
export const getSubmarkLogo = (logoString: string) => {
  const allLogos = logoString.split(",");
  return allLogos[0]; //submark logo's index
};

export const getFullName = (firstName: string | null, lastName: string | null) => {
  return firstName === null || lastName === null
    ? "-"
    : `${firstName.charAt(0).toUpperCase()}${firstName?.slice(1)} ${lastName.charAt(0).toUpperCase()}${lastName?.slice(1)}`;
};
export const isValidUrl = (urlString: string) => {
  try {
    new URL(urlString);
    return true;
  } catch (error) {
    return false;
  }
};
export const capitalizeWords = (str: string | null) => {
  if (str === null || str === "") {
    return str;
  }

  return str
    .trim()
    .split(" ")
    .map((word) => {
      if (word.length === 0) {
        return word;
      }
      return word[0].toUpperCase() + word.slice(1);
    })
    .join(" ");
};
export const convertToTitleCase = (input: string): string => {
  if (input === undefined || input === null) {
    return "";
  }
  if (/^[a-z][A-Za-z]*$/.test(input) || /^[A-Z][A-Z]*[a-z]*$/.test(input)) {
    return input
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase
      .split(/[-_]/) // Split by dashes and underscores
      .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
      .join(" ");
  }

  // Normalize input with dashes and underscores
  const normalized = input.replace(/[-_]/g, " ");
  const capitalizedWords = normalized.split(" ").map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`);
  return capitalizedWords.join(" ");
};

export const getBrandLogo = (manufacturer: string) => {
  let logo;
  switch (manufacturer.toLowerCase()) {
    case "adidas":
      logo = require("@/assets/images/adidas.png");
      break;
    case "nike":
      logo = require("@/assets/images/nike.png");
      break;
    case "puma":
      logo = require("@/assets/images/puma.png");
      break;
    case "under armour":
      logo = require("@/assets/images/under-armour.png");
      break;
    case "new balance":
      logo = require("@/assets/images/new-balance.png");
      break;
    default:
      logo = require("@/assets/images/logo-avatar.svg");
      break;
  }
  return logo;
};

export const isValidImageUrl = (url: string | null | undefined): boolean => {
  if (typeof url !== "string" || url.length === 0) {
    return false;
  }
  const regex = /^https:\/\/.*\.(jpeg|jpg|png|svg|gif|bmp|webp|tiff)$/i;
  return regex.test(url);
};

export const convertArrayToObjects = (inputArray: string[]) => {
  if (!Array.isArray(inputArray)) {
    throw new Error("Input is not an array");
  }
  const labelValueMap: Record<string, number> = {
    adidas: 14,
    nike: 18,
    "under armour": 23,
    "new balance": 591,
    puma: 592,
  };
  return inputArray.map((stringValue) => ({
    ["label"]: stringValue,
    value: labelValueMap[stringValue] || 0,
  }));
};

export function removeKeys<T extends { __typename?: string }>(object: T, keysToRemove: Array<keyof T>): T {
  const newObject = { ...object };
  for (const key of keysToRemove) {
    if (newObject && typeof newObject === "object") delete newObject[key];
  }
  return { ...newObject };
}
